import { Button, Checkbox, DraggableWindowHeader } from "@hoylu/client-common";
import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestDelete } from "../../state/user/user.actions";
import { user } from "../../state/user/user.selector";
import { cancelDashboardOption } from "../../state/workspaces/workspaces.actions";
import { Localized } from "../../strings";
import Styles from "./ConfirmAccountDelete.module.css";
import { Modal } from "./Modal";

export const ConfirmAccountDelete = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(user);
  const [confirm, setConfirm] = useState(false);
  const strings = Localized.object("CONFIRM_ACCOUNT_DELETE");
  const close = useCallback(
    () => dispatch(cancelDashboardOption()),
    [dispatch],
  );
  const tClose = Localized.object("CLOSE_BUTTON");

  return (
    <Modal handleOutsideClick={close}>
      <DraggableWindowHeader
        close={tClose.CLOSE}
        onClose={close}
        title={strings.TITLE + currentUser.profile.email}
      />
      <div className={Styles.confirmAccountDelete}>
        <span>{strings.P1}</span>
        <ul className={Styles.stepList}>
          <li className={Styles.listItem}>{strings.POINT1}</li>
          <li className={Styles.listItem}>{strings.POINT2}</li>
        </ul>
        <span className={Styles.confirmationEmailInfo}>{strings.P2}</span>
      </div>
      <div className={Styles.footer}>
        <div className={Styles.confirm}>
          <Checkbox checked={confirm} onChange={setConfirm}>
            {strings.CONFIRM}
          </Checkbox>
        </div>
        <div className={Styles.buttons}>
          <Button onClick={close} toolTip={strings.CANCEL} type="primary">
            {strings.CANCEL}
          </Button>
          <Button
            disabled={!confirm}
            onClick={() => dispatch(requestDelete.request())}
            toolTip={strings.DELETE}
            type="attention"
          >
            {strings.DELETE}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
